import React from 'react';

const BenefitTable = ({ data }) => {
  const valueKeys = Array.from(
    new Set(data.flatMap(item => Object.keys(item.values)))
  );
  
  const headers = [
    'Benefit Type',
    'Date',
    'Remedy Choice',
    'Retirement Type',
    ...valueKeys.map(key => `Value (${key})`)
  ];

  return (
    <table border="1">
      <thead>
        <tr>
          {headers.map(header => (
            <th key={header}>{header}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map(item => (
          <tr key={item.id}>
            <td>{item.benefitType}</td>
            <td>{item.date}</td>
            <td>{item.remedyChoice}</td>
            <td>{item.retirementType}</td>
            {valueKeys.map(key => (
              <td key={key}>{item.values[key] || 'N/A'}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default BenefitTable;
